export const timeLock = "0x159b89366c799B586e9A66EbD3e4d5fC075Fa29F";
export const workingNetwork = "0x4";
